import { render, staticRenderFns } from "./RobberyTypeQuestion.vue?vue&type=template&id=2b2abc67&scoped=true"
import script from "./RobberyTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyTypeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2abc67",
  null
  
)

export default component.exports